/*
 * Globalize Culture de-CH
 *
 * http://github.com/jquery/globalize
 *
 * Copyright Software Freedom Conservancy, Inc.
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * This file was generated by the Globalize Culture Generator
 * Translation: bugs found in this file need to be fixed in the generator
 */

(function(window, undefined) {
    let Globalize;

    if (
        typeof require !== 'undefined' &&
        typeof exports !== 'undefined' &&
        typeof module !== 'undefined'
    ) {
        // Assume CommonJS
        Globalize = require('globalize');
    } else {
        // Global variable
        Globalize = window.Globalize;
    }

    Globalize.addCultureInfo('de-CH', 'default', {
        name: 'de-CH',
        englishName: 'German (Switzerland)',
        nativeName: 'Deutsch (Schweiz)',
        language: 'de',
        numberFormat: {
            ',': "'",
            NaN: 'n. def.',
            negativeInfinity: '-unendlich',
            positiveInfinity: '+unendlich',
            percent: {
                pattern: ['-n%', 'n%'],
                ',': "'",
            },
            currency: {
                pattern: ['$-n', '$ n'],
                ',': "'",
                symbol: 'Fr.',
            },
        },
        calendars: {
            standard: {
                '/': '.',
                firstDay: 1,
                days: {
                    names: [
                        'Sonntag',
                        'Montag',
                        'Dienstag',
                        'Mittwoch',
                        'Donnerstag',
                        'Freitag',
                        'Samstag',
                    ],
                    namesAbbr: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
                    namesShort: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
                },
                months: {
                    names: [
                        'Januar',
                        'Februar',
                        'März',
                        'April',
                        'Mai',
                        'Juni',
                        'Juli',
                        'August',
                        'September',
                        'Oktober',
                        'November',
                        'Dezember',
                        '',
                    ],
                    namesAbbr: [
                        'Jan',
                        'Feb',
                        'Mrz',
                        'Apr',
                        'Mai',
                        'Jun',
                        'Jul',
                        'Aug',
                        'Sep',
                        'Okt',
                        'Nov',
                        'Dez',
                        '',
                    ],
                },
                AM: null,
                PM: null,
                eras: [{ name: 'n. Chr.', start: null, offset: 0 }],
                patterns: {
                    d: 'dd.MM.yyyy',
                    D: 'dddd, d. MMMM yyyy',
                    I: 'dddd, d. MMMM',
                    t: 'HH:mm',
                    T: 'HH:mm:ss',
                    f: 'dddd, d. MMMM yyyy HH:mm',
                    F: 'dddd, d. MMMM yyyy HH:mm:ss',
                    M: 'dd MMMM',
                    Y: 'MMMM yyyy',
                },
            },
        },
    });
})(this);
